enum LoginAsOptions {
    Client = 'client',
    Employee = 'employee',
    Admin = 'admin',
}

export { LoginAsOptions };
